import React, { useState, useEffect } from "react";
import { CssBaseline, Paper, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import Review from "../Review";
import useStyles from "./styles";

const Checkout = ({ cart, setCheckedCart, onCaptureCheckout }) => {
  const classes = useStyles();

  const [checkedCartLocal, setCheckedCartLocal] = useState(null);

  const checkCart = async () => {
    //retrieve cart data
    //post the values to api
    try {
      const response = await fetch(process.env.REACT_APP_API_CART_AVAILABILITY_CHECK, {
        method: "POST",
        body: JSON.stringify({ cart }),
        headers: { "Content-Type": "application/json" }
      });

      const data = await response.json();
      console.log("Cart data is: " + JSON.stringify(data));

      setCheckedCart(data);
      setCheckedCartLocal(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    checkCart();
  }, []);

  if (checkedCartLocal != null) {
    return (
      <>
        <Helmet>
          <title>Manuel Fridman&apos;s Jewelry Checkout</title>
          <meta name="description" content="Jewelry shop checkout" />
        </Helmet>
        <CssBaseline />
        <div className={classes.toolbar} />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography variant="h4" align="center">
              Checkout
            </Typography>

            <Review cart={cart} checkedCart={checkedCartLocal} onCaptureCheckout={onCaptureCheckout} />
          </Paper>
        </main>
      </>
    );
  }
};

export default Checkout;
